import moment from "moment";

export default {
  date: (value: Date | string, format: string) => {
    if (value) {
      if (format) {
        return moment.utc(value).local().format(format);
      } else {
        return moment.utc(value).local().format("DD/MM/YYYY");
      }
    }
    return "";
  },
  ago: (value: Date | string) => {
    if (value) {
      return moment.utc(value).local().fromNow();
    }
    return "";
  },
  numberFormat: (value: number = 0): string => {
    return new Intl.NumberFormat().format(value);
  },
  time: (value: string) => {
    if (value) {
      const splitTime = value.split(":");
      const result = splitTime[0] + ":" + splitTime[1];

      const date = new Date();
      date.setHours(parseInt(splitTime[0]), parseInt(splitTime[1]));
      const dateEnd = new Date();
      dateEnd.setHours(date.getHours() + 1, date.getMinutes() + 30);
      const hourEnd =
        dateEnd.getHours() < 10 ? `0${dateEnd.getHours()}` : dateEnd.getHours();
      const minEnd =
        dateEnd.getMinutes() < 10
          ? `0${dateEnd.getMinutes()}`
          : dateEnd.getMinutes();

      const resultEnd = `${hourEnd}:${minEnd}`;
      return result.toString() + " - " + resultEnd.toString();
    }
    return "";
  },
  secondsToTime: (value) => {
    if (value) {
      const date = new Date(0);
      date.setSeconds(value);
      return date.toISOString().substring(11, 19);
    }
    return "00:00:00";
  },
};
